import React, { useEffect } from "react";
import BreadCrumb from "../Components/BreadCrumb";
import InnerBanner from "../Components/InnerBanner";
import Spinner from "../Components/Spinner";
import { useGetLatestNewsQuery } from "../../../redux/services/internal/apiHome";

const WhatsNewDetail = ({ benchId }) => {
  const { data: latestNews, isLoading, isError } = useGetLatestNewsQuery();

  if (isLoading) {
    return <Spinner />;
  }

  if (isError) {
    return <div>Error fetching gallery data!</div>;
  }
  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        <BreadCrumb title="Latest News" />
        <div className="about-bg inner-page-section">
          <div className="container">
            <div className="table-responsive mt-4">
              <table className="table table-bordered whatsnew-tble">
                <thead>
                  <tr>
                    <th>Sr.No.</th>
                    <th>Title</th>
                    {/* <th>Description</th> */}
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {latestNews && latestNews.data ? (
                    latestNews.data.map((news, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{news.title}</td>
                        {/* <td>
                        <p>{news.description}</p>
                      </td> */}
                        <td>
                          <a
                            className=""
                            target={"_blank"}
                            href={news.upload_image_path}
                          >
                            Read&nbsp;More
                          </a>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tbody>
                      <tr>
                        <td colSpan={4}> No Record Found </td>
                      </tr>
                    </tbody>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WhatsNewDetail;
